import { getCashAvailableFactors } from 'api/v2/transactions/cashAvailable';
import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import { useQuery } from 'react-query';
import { BankTransactionsCacheKeys } from 'types/cacheKeys.types';
import type { CashAvailableFactorsType } from 'types/transactions.types';

const useCachAvailable = () => {
  const { data: user } = useGetCurrentCustomerData();

  return useQuery<CashAvailableFactorsType>(
    [BankTransactionsCacheKeys.CashAvailableFactors],
    getCashAvailableFactors,
    { enabled: !!user?._id },
  );
};

export default useCachAvailable;
